import { message } from 'ant-design-vue';

const extractApiErrorMessage = (error, fallbackMessage) => {
  const responseData = error?.response?.data;
  const validationErrors = responseData?.errors;

  if (validationErrors && typeof validationErrors === 'object') {
    const firstValidationMessage = Object.values(validationErrors)
      .flat()
      .find((item) => typeof item === 'string' && item.trim());

    if (firstValidationMessage) {
      return firstValidationMessage;
    }
  }

  if (typeof responseData?.message === 'string' && responseData.message.trim()) {
    return responseData.message;
  }

  if (typeof error?.message === 'string' && error.message.trim()) {
    return error.message;
  }

  return fallbackMessage;
};

const showApiError = (error, fallbackMessage) => {
  message.error(extractApiErrorMessage(error, fallbackMessage));
};

export { extractApiErrorMessage, showApiError };
